import React, { useState, useContext, useEffect } from "react";
// import { Link, useLocation } from "react-router-dom";
import axios from "../../helper/axios";
import { AuthContext } from "../../context/AuthContext";
import DashSidebar from "./DashSidebar";
import ClipboardCopy from "../ClipboardCopy";
import Compressor from "compressorjs";

const ImageUploader = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [imageUrl, getImageUrl] = useState();
  // const [imageName, getImageName] = useState();
  const { token } = useContext(AuthContext);
  const [imageSizes, setImageSizes] = useState([]);

  const getActiveClass = (route) => {
    return location.pathname === route ? "active" : "";
  };

  const compressImage = async (imageFile) => {
    return new Promise((resolve, reject) => {
      new Compressor(imageFile, {
        quality: 0.6,
        maxWidth: 1920,
        maxHeight: 1920,
        success: (result) => {
          const compressedFile = new File([result], imageFile.name);
          resolve({ file: compressedFile, size: compressedFile.size });
        },
        error: (error) => {
          console.error("Error compressing image:", error);
          reject(error);
        },
      });
    });
  };

  const handleUpload = async () => {
    if (selectedFile.length > 0) {
      const compressedFiles = [];

      for (const file of selectedFile) {
        const compressedFile = await compressImage(file);
        compressedFiles.push(compressedFile.file);
      }

      const sizes = compressedFiles.map((file) => file.size);
      setFileSizes(sizes);

      const formData = new FormData();

      // for (const file of compressedFiles) {
      //   formData.append("images", file);
      // }
      for (let i = 0; i < selectedFile.length; i++) {
        formData.append("images", compressedFiles[i], selectedFile[i].name);
      }

      const token = localStorage.getItem("token");
      console.log(selectedFile, "selectedFile");
      axios
        .post("/insert_image", formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response.data); // Handle success response
          alert("Images Added");
          handleFetchImage();
        })
        .catch((error) => {
          console.error(error); // Handle error
        });
    } else {
      alert("Please Select Image!");
    }
  };

  // const handleFetchImage = () => {
  //   const token = localStorage.getItem("token");

  //   axios
  //     .get("/get_image", {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     })
  //     .then((response) => {
  //       // const contentLength = response.headers["content-length"];
  //       // console.log(contentLength, "Data321");
  //       const imageUrlData = response.data.image_urls;
  //       getImageUrl(imageUrlData);

  //       // Fetch and store image sizes
  //       const sizesPromises = imageUrlData.map(async (url) => {
  //         const headResponse = await axios.head(url);
  //         const contentLength = headResponse.headers["content-length"];
  //         console.log("Content Length:", contentLength);
  //         return contentLength;
  //       });

  //       Promise.all(sizesPromises)
  //         .then((sizes) => {
  //           console.log("Image Sizes:", sizes);
  //           setImageSizes(sizes);
  //         })
  //         .catch((error) => {
  //           console.error(error); // Handle error
  //         });
  //       // const sizes = imageUrlData.map((url) => {
  //       //   const contentLength = response.headers['content-length'];
  //       //   return contentLength;
  //       // });
  //       // setImageSizes(sizes);

  //       // var imagename = imageUrlData
  //       //   .toString()
  //       //   .split(
  //       //     "http://ec2-34-197-250-249.compute-1.amazonaws.com/static/maitri_products/"
  //       //   )
  //       //   .pop();
  //       // getImageName(imagename);
  //     })
  //     .catch((error) => {
  //       console.error(error); // Handle error
  //     });
  // };
  useEffect(() => {
    handleFetchImage();
  }, []);

  const handleFetchImage = () => {
    const token = localStorage.getItem("token");

    axios
      .get("/get_image", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const imageUrlData = response.data.image_urls;
        getImageUrl(imageUrlData);

        // Fetch and store image sizes
        const sizesPromises = imageUrlData.map((url) => {
          return axios
            .head(url)
            .then((headResponse) => {
              const contentLength = headResponse.headers["content-length"];
              // console.log("Content Length:", contentLength);

              if (!isNaN(contentLength)) {
                return contentLength;
              } else {
                console.log("Invalid content length:", contentLength);
                return 0; // Use a default value or handle the error
              }
            })
            .catch((error) => {
              // console.error("Error fetching content length:", error);
              return 0; // Use a default value or handle the error
            });
        });

        Promise.all(sizesPromises)
          .then((sizes) => {
            // console.log("Image Sizes:", sizes);
            setImageSizes(sizes);
          })
          .catch((error) => {
            console.error("Error fetching image sizes:", error);
          });
      })
      .catch((error) => {
        console.error("Error fetching image URLs:", error);
      });
  };

  const handleImageDelete = (imageName) => {
    if (window.confirm("Are you sure you want to delete this Image ?")) {
      const token = localStorage.getItem("token");

      axios
        .post(
          "/delete_image",
          { image_names: [imageName] },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          console.log("Image deleted:", imageName);
          // You can also update the state to remove the deleted image if needed
          handleFetchImage();
        })
        .catch((error) => {
          console.error("Error deleting image:", error);
        });
    }
  };

  return (
    <>
      <section className="mt-3">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-2">
              <DashSidebar activeClass={getActiveClass("/dashboard")} />
            </div>
            <div className="col-sm-10 light-border p-4">
              <h3 className="mb-5">
                <b>Media</b>
              </h3>

              <div className="mb-4">
                <p className="d-inline-block me-5">
                  <b>Upload Images :-</b>
                </p>
                <input
                  className="m-0"
                  name="images"
                  required
                  accept="image/*"
                  type="file"
                  multiple
                  onChange={(e) => {
                    setSelectedFile(e.target.files),
                      console.log(e.target.files);
                  }}
                />
                <button className="btn btn__primary" onClick={handleUpload}>
                  Upload
                </button>
                {/* <button className="btn btn__outline me-4" onClick={handleFetchImage}>Fetch</button> */}
              </div>
              <hr />

              <div>
                <ul className="p-0 d-flex justify-content-between flex-wrap">
                  {imageUrl &&
                    imageUrl.map((curElem, index) => {
                      const imageNameFromUrl = curElem.substring(
                        curElem.lastIndexOf("/") + 1
                      );
                      const urlParts = curElem.split("/");
                      const truncatedUrl = `${urlParts[0]}//${urlParts[2]}.../${
                        urlParts[urlParts.length - 1]
                      }`;
                      return (
                        <li
                          className="w-100 d-flex align-item-center image-url-list"
                          key={index}
                        >
                          <p className="me-4">{index}</p>
                          <img
                            className="file-name"
                            src={curElem
                              .toString()
                              .split(
                                "http://ec2-34-197-250-249.compute-1.amazonaws.com/static/maitri_products/"
                              )
                              .pop()}
                            alt={`Image ${index}`}
                          />
                          <p className="me-3 mb-0">{imageNameFromUrl}</p>
                          {/* <span className="file-size">
                            {formatFileSize(imageSizes[index])} bytes
                          </span> */}
                          <ClipboardCopy
                            copyText={`${curElem}`}
                            fileSize={imageSizes[index]}
                          />
                          <button
                            className="btn me-2"
                            onClick={() => handleImageDelete(imageNameFromUrl)}
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </li>
                      );
                    })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ImageUploader;
